<template>
  <div class="filter-wrap" :class="{ 'shop-filters': currentRouteIsCoatings }">
    <div class="color-filters">
      <span>Colors</span>
      <ul class="color-filters-list">
        <li v-for="(filter, index) in colorFilters" :key="index" :aria-label="`Filter by ${filter.name}`">
          <input aria-hidden="true" type="checkbox" :id="`toggle-filters[${index}]`" :checked="filter.checked"
            :value="filter.code" @change="toggleColorFilter(filter.code)">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ColorFilters",

  computed: {
    ...mapGetters([
      'colorFilters'
    ]),

    currentRouteIsCoatings() {
      return window.location.pathname === '/shop/cerakote-coating';
    }
  },

  methods: {
    ...mapActions([
      'toggleColorFilter'
    ])
  }
}
</script>
